/* NicheMerch homepage behaviour: hero hat carousel, rotating reviews, off-screen animation pausing.
   No dependencies. Does no per-frame work while idle, and nothing at all while off-screen or in a background tab. */
(function () {
  'use strict';
  if (window.__nmHome) return;
  window.__nmHome = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ease = function (p) { return p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2; };
  var HOLD = 2600, MOVE = 950, SETTLE = 450, AFTER_TOUCH = 4500;

  /* ---------- hero carousel ---------- */
  function initCarousel(el) {
    var slots = Array.prototype.slice.call(el.querySelectorAll('.nm-slot'));
    var N = slots.length;
    if (N < 2) { el.classList.add('nm-ready'); return; }

    var s = { base: 0, t: 0, front: 0, phase: 'hold', visible: true, hover: false, drag: null, timer: 0, raf: 0, W: 0, H: 0 };

    /* hats that start hidden behind the front one load on idle, and always one step before they are needed */
    function hydrate(i) {
      var img = slots[((i % N) + N) % N].firstElementChild;
      if (img && !img.getAttribute('src') && img.getAttribute('data-src')) {
        if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
        img.setAttribute('src', img.getAttribute('data-src'));
      }
    }
    function hydrateAll() { for (var i = 0; i < N; i++) hydrate(i); }
    function whenIdle() {
      var front = slots[0].firstElementChild;
      var neighbours = function () { hydrate(1); hydrate(N - 1); };
      var rest = function () { if ('requestIdleCallback' in window) requestIdleCallback(hydrateAll, { timeout: 2500 }); else setTimeout(hydrateAll, 1200); };
      var afterFront = function () { neighbours(); rest(); setTimeout(upgradeFront, 600); };
      if (front && front.complete && front.naturalWidth) afterFront(); else if (front) { front.addEventListener('load', afterFront, { once: true }); front.addEventListener('error', afterFront, { once: true }); } else afterFront();
      setTimeout(hydrateAll, 8000);  /* safety net */
    }

    /* the first hat ships inside the HTML (480px); on dense screens swap in the 600px file once the page is idle */
    function upgradeFront() {
      var img = slots[0].firstElementChild, hi = img && img.getAttribute('data-hires');
      if (hi && (window.devicePixelRatio || 1) >= 2.4) img.setAttribute('src', hi);
    }

    function measure() { s.W = el.clientWidth; s.H = el.clientHeight; layout(); }

    function layout() {
      var W = s.W, H = s.H, wide = W > 500;
      var fw = W * (wide ? .5 : .56), Rx = W * (wide ? .34 : .31), ymax = H * (wide ? .2 : .19);
      for (var i = 0; i < N; i++) {
        var ph = 2 * Math.PI * (i - s.t) / N, d = (Math.cos(ph) + 1) / 2;
        var el2 = slots[i], sc = .5 + .5 * d;
        el2.style.width = fw + 'px';
        el2.style.transform = 'translateX(-50%) translate(' + (Math.sin(ph) * Rx).toFixed(1) + 'px,' + (-(1 - d) * ymax).toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        el2.style.zIndex = Math.round(d * 100) + 10;
        el2.firstElementChild.style.filter = 'drop-shadow(0 ' + (4 + d * 12).toFixed(1) + 'px ' + (5 + d * 7).toFixed(1) + 'px rgba(40,10,60,' + (.1 + d * .16).toFixed(2) + ')) brightness(' + (.84 + .16 * d).toFixed(3) + ')';
      }
      var f = ((Math.round(s.t) % N) + N) % N;
      if (f !== s.front) { s.front = f; markFront(); }
    }

    function markFront() {
      for (var i = 0; i < N; i++) {
        var isFront = i === s.front;
        slots[i].tabIndex = isFront ? 0 : -1;
        slots[i].setAttribute('aria-hidden', isFront ? 'false' : 'true');
      }
    }

    function animate(from, to, ms, done) {
      cancelAnimationFrame(s.raf);
      var t0 = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - t0) / ms);
        s.t = from + (to - from) * ease(p);
        layout();
        if (p < 1) s.raf = requestAnimationFrame(step); else done();
      })(t0);
    }

    function schedule(ms) {
      clearTimeout(s.timer);
      if (reduce.matches || !s.visible || s.hover || document.hidden || s.drag || s.phase !== 'hold') return;
      s.timer = setTimeout(next, ms == null ? HOLD : ms);
    }

    function goTo(target, ms) {
      hydrate(Math.round(target)); hydrate(Math.round(target) + 1); hydrate(Math.round(target) - 1);
      clearTimeout(s.timer);
      s.phase = 'move';
      var from = s.t;
      if (reduce.matches) { s.t = s.base = target; layout(); s.phase = 'hold'; return; }
      animate(from, target, ms || MOVE, function () { s.base = target; s.t = target; s.phase = 'hold'; schedule(); });
    }

    function next() { if (s.phase === 'hold') goTo(s.base + 1); }

    /* dragging: follows the finger, then settles on the nearest hat */
    var moved = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      hydrateAll();
      clearTimeout(s.timer); cancelAnimationFrame(s.raf);
      s.phase = 'drag'; moved = 0;
      s.drag = { x: e.clientX, t: s.t, lx: e.clientX, lt: performance.now(), v: 0 };
      try { el.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      el.classList.add('nm-grab');
    });
    el.addEventListener('pointermove', function (e) {
      var d = s.drag; if (!d) return;
      var now = performance.now();
      d.v = (e.clientX - d.lx) / Math.max(1, now - d.lt); d.lx = e.clientX; d.lt = now;
      moved = Math.max(moved, Math.abs(e.clientX - d.x));
      s.t = d.t - (e.clientX - d.x) / (s.W * .45);
      layout();
    });
    function endDrag() {
      var d = s.drag; if (!d) return;
      s.drag = null; el.classList.remove('nm-grab');
      var fling = Math.max(-.5, Math.min(.5, -d.v * 110 / (s.W * .45)));
      var target = Math.round(s.t + fling);
      s.phase = 'settle';
      var from = s.t;
      if (reduce.matches) { s.t = s.base = target; layout(); s.phase = 'hold'; return; }
      animate(from, target, SETTLE, function () { s.base = target; s.t = target; s.phase = 'hold'; schedule(AFTER_TOUCH); });
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);

    /* tapping a side hat brings it forward; tapping the front hat follows its link */
    slots.forEach(function (slot, i) {
      slot.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); return; }
        if (i !== s.front) {
          e.preventDefault();
          var delta = ((i - s.front + N + N / 2) % N) - N / 2;
          clearTimeout(s.timer); goTo(Math.round(s.t) + delta, SETTLE + 150);
        }
      });
    });

    /* keyboard + screen readers */
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.round(s.t) + 1, SETTLE + 150); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.round(s.t) - 1, SETTLE + 150); }
    });
    var prev = el.querySelector('[data-nm-prev]'), nextBtn = el.querySelector('[data-nm-next]');
    if (prev) prev.addEventListener('click', function () { goTo(Math.round(s.t) - 1, SETTLE + 150); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(Math.round(s.t) + 1, SETTLE + 150); });

    /* pause rules */
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { s.hover = true; clearTimeout(s.timer); } });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { s.hover = false; schedule(); } });
    document.addEventListener('visibilitychange', function () { clearTimeout(s.timer); if (!document.hidden) schedule(); });
    if (reduce.addEventListener) reduce.addEventListener('change', function () { clearTimeout(s.timer); schedule(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        s.visible = entries[0].isIntersecting;
        if (s.visible) schedule(); else clearTimeout(s.timer);
      }).observe(el);
    }
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(el); else window.addEventListener('resize', measure);

    markFront();
    measure();
    el.classList.add('nm-ready');
    whenIdle();
    schedule();
  }

  /* ---------- rotating reviews ---------- */
  function initReviews(el) {
    var qs = Array.prototype.slice.call(el.querySelectorAll('.nm-q'));
    var dots = Array.prototype.slice.call(el.querySelectorAll('.nm-rdots button'));
    if (qs.length < 2) return;
    var i = 0, timer = 0, visible = true, hover = false;
    function show(n) {
      i = (n + qs.length) % qs.length;
      qs.forEach(function (q, k) { q.classList.toggle('nm-on', k === i); q.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('nm-on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function tick() { clearInterval(timer); if (!reduce.matches && visible && !hover && !document.hidden) timer = setInterval(function () { show(i + 1); }, 6000); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); tick(); }); });
    el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; tick(); } });
    el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') { hover = false; tick(); } });
    document.addEventListener('visibilitychange', tick);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; tick(); }).observe(el);
    show(0); tick();
  }

  /* ---------- pause decorative animation while off-screen ---------- */
  function initPause(el) {
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { el.classList.toggle('nm-off', !en[0].isIntersecting); }).observe(el);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nm-car]'), initCarousel);
    Array.prototype.forEach.call(document.querySelectorAll('[data-nm-reviews]'), initReviews);
    Array.prototype.forEach.call(document.querySelectorAll('[data-nm-pause]'), initPause);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
